import { createChallengeGateFetch, waitForChallenge } from './challengeGate';
import { RecoveryController } from './controller';
import { createRecoveryFetch } from './transport';

declare global {
  interface Window {
    fastlyActionRecovery?: RecoveryController;
    fastlyChallengeGate?: { readonly original: typeof fetch };
  }
}

export function installChallengeGate(target: Window): void {
  if (
    !target.fastlyChallengeGate &&
    target.document.documentElement.dataset.fastlyChallenge === 'true'
  ) {
    const original = target.fetch.bind(target);
    target.fastlyChallengeGate = { original };
    target.fetch = createChallengeGateFetch(
      original,
      target.location.origin,
      (): string => target.document.baseURI
    );
  }
}

export function installRecovery(target: Window): RecoveryController | undefined {
  if (
    !target.fastlyActionRecovery &&
    target.document.documentElement.dataset.fastlyChallenge === 'true'
  ) {
    const controller = new RecoveryController({
      origin: target.location.origin,
      attemptId: (): string => target.crypto.randomUUID(),
      report: (detail): void => {
        target.dispatchEvent(new CustomEvent('fastly-recovery-outcome', { detail }));
      }
    });
    target.fastlyActionRecovery = controller;
    target.addEventListener('message', controller.receive);
    target.addEventListener('pagehide', controller.navigate);
    target.addEventListener('popstate', controller.navigate);
    target.fetch = createRecoveryFetch(
      target.fastlyChallengeGate?.original ?? target.fetch.bind(target),
      controller,
      target.location.origin,
      (): string => target.document.baseURI,
      target.fastlyChallengeGate ? waitForChallenge : undefined
    );
  }
  return target.fastlyActionRecovery;
}
